/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import Link from '../../components/Link';
import s from './Urzad.css';
import { wybierzGmine } from '../../actions/gminy';
import PaperTile from '../../components//PaperTile/PaperTile';
import PaperHeader from '../../components/PaperHeader/PaperHeader';
import fetch from '../../core/fetch';
import { notFoundImageURL } from '../../config';
import { replaceMultipleSpaces } from '../../lib/utils';


class Urzad extends React.Component {
  // onClickGmina = (e) => {
  //   this.props.wybierzGmine(e);
  // };
  state = {
    filter_text: ''
  };

  districtFilterChange = (e) => {
    //zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  render() {
    return (
      <div className="urzad-cont">
        <PaperHeader title="Lista zarejestrowanych urzędów" />
        <input type="text"
          className="form-control"
          style={{ width: '60%', left: '20%', position: 'relative', margin: '25px 0px 15px 0px' }}
          value={this.state.filter_text}
          placeholder="Wyszukaj urząd..."
          onChange={(e) => this.districtFilterChange(e)}
          aria-label="Wprowadź tekst aby wyszukać urząd"
        />
        <div className="row">
          {this.props.districts && Object.keys(this.props.districts)
            .filter(v => this.props.districts[v].name.toLowerCase().includes(this.state.filter_text.toLowerCase()))
            .map((v, i) => {
              if (this.props.districts[v].showOnList) {
                return (<div key={i} className="col-xs-12 col-sm-6 col-md-4">
                  <PaperTile
                    href={`/urzad/${this.props.districts[v].prefix}`}
                    text={this.props.districts[v].name}
                    herb={this.props.districts[v].herb ?
                      `${process.env.OLD_IHUB}/upload/herby/${this.props.districts[v].herb}`
                      : notFoundImageURL
                    }
                    style={{ fontWeight: 'bold' }}
                  />
                </div>)
              }
            }
            )}
        </div>
      </div>
    );
  }
}

// export default withStyles(s)(Urzad);

const mapState = (state) => ({
  wybranaGmina: state.gminy.wybranaGmina,
  districts: state.district.districts
});

const mapDispatch = {
  wybierzGmine,
};

export default withStyles(s)(connect(mapState, mapDispatch)(Urzad));



// WEBPACK FOOTER //
// src/routes/urzad/Urzad.js